import { PROCESS_STEPS } from "@/lib/process-steps";
import { Card } from "@/components/ui/card";

export function ProductProcessFlow() {
  return (
    <div className="grid md:grid-cols-4 gap-6">
      {PROCESS_STEPS.map((step, index) => (
        <Card key={index} className="p-6">
          <div
            className={`w-12 h-12 rounded-xl ${step.bgColor} flex items-center justify-center mb-4`}
          >
            <step.icon className={`w-6 h-6 ${step.color}`} />
          </div>
          <h3 className="text-lg font-bold mb-2">{step.title}</h3>
          <p className="text-sm text-muted-foreground">{step.shortDescription}</p>
        </Card>
      ))}
    </div>
  );
}
